/* eslint-disable mastery/known-imports */
import {
  LOCAL_STORAGE_LD_USER_IDENTIFIERS,
  STARTED_WITH_USER_DATA,
  UserData,
} from '@components/AuthContext';
import { isPRPreview } from '@utils/constants';
import { RESOLVED_TENANT } from '@utils/getTenantFromDomain';
import { setLocalStorage } from '@utils/localStorage';
import { reportCustomError } from '@utils/reportCustomError';
import { sentry } from '@utils/sentry';
import { win } from '@utils/win';
import { LDClient, LDMultiKindContext } from 'launchdarkly-js-client-sdk';
interface SetUserArg {
  ldClient?: LDClient;
  data: UserData;
}
export const setUserData = async (arg: SetUserArg): Promise<void> => {
  const { ldClient, data } = arg;
  const { email, name, key } = data;
  let hostname = win.location.hostname;
  if (isPRPreview(hostname)) {
    hostname = 'pull';
  }
  setLocalStorage(LOCAL_STORAGE_LD_USER_IDENTIFIERS, {
    email,
    name,
    key,
    hostname,
  });

  try {
    if (!STARTED_WITH_USER_DATA && ldClient) {
      // Get current context to preserve other kinds
      const currentContext = ldClient.getContext();

      // Build new context preserving existing kinds
      let newContext;

      if (
        currentContext &&
        'kind' in currentContext &&
        currentContext.kind === 'multi'
      ) {
        // Preserve multi-kind context, only update user kind
        // Extract context kinds explicitly instead of using spread operator
        const multiContext = currentContext as unknown as LDMultiKindContext;
        newContext = {
          kind: 'multi' as const,
          user: {
            kind: 'user' as const,
            name,
            email,
            key: key || 'unknown',
            hostname: hostname,
          },
          component: multiContext.component,
          env: multiContext.env,
          ...(multiContext.tenant && { tenant: multiContext.tenant }),
        };
      } else {
        // Fallback to single-kind if no multi-context exists
        newContext = {
          kind: 'user' as const,
          name,
          email,
          key: key || 'unknown',
          hostname: hostname,
        };
      }

      await ldClient.identify(newContext);
    }
  } catch (ldErr) {
    reportCustomError(ldErr as string);
  }
  // SENTRY
  sentry.configureScope((scope) => {
    scope.setUser({ email });
  });
};
// https://support.walkme.com/knowledge-base/variables/
export const setWalkmeVariables = (
  data: UserData & Record<string, Maybe<string>>,
): void => {
  const { name, email, key } = data;
  win.masteryWalkmeVariables = {
    ...data,
    name: name || 'unknown',
    email: email || 'unknown',
    tenant: RESOLVED_TENANT,
    host: win.location.host,
    key,
  };
};
